import {uuid} from "vue-uuid";
import store from "@/store";
import {ConnectionPool} from "./ConnectionPool";
import WorkerTimer from "@/plugins/WorkerTimer";

export default {
	initialize() {
		this.uniqueID = `live-console-${uuid.v1()}`;
		this.userName = store.getters.getUserFullName();
		this.connectionPool = new ConnectionPool(this);

		this.invoiceSubscription();
	},

	addSubscription(topic) {
		this.connectionPool.addSubscription(topic);
	},

	removeSubscription(topic) {
		this.connectionPool.removeSubscription(topic);
	},

	publish(topic, msg, receipt, shouldStringfyReceipt = false) {
		let invoiceRequest;
		if (receipt) {
			invoiceRequest = {
				InvoiceFrom: `UI: ${this.uniqueID}`,
				InvoiceId: uuid.v1(),
				InvoiceTopic: topic,
				InvoiceDescription: `UI/${this.uniqueID} UI Request for UI`,
				RequestReceipt: receipt,
				ZeroMQReceipt: `UI.InvoiceReceipt.${this.uniqueID}`,
			};
		}

		const data = invoiceRequest ?
		             JSON.stringify([msg, shouldStringfyReceipt ? JSON.stringify(invoiceRequest) : invoiceRequest]) :
		             msg;

		try {
			this.connectionPool.publish(topic, data);
		} catch (ex) {
			console.log(`Error in publish of ConnectionPool: ${ex}`);
		}
	},

	closeConnection() {
		this.connectionPool.unsubscribeAll();
		this.connectionPool.closeAll();
	},

	refreshConnection() {
		if (this.connectionPool) {
			this.connectionPool.reconnectClients();
		}
	},

	onMessageArrived(topic, message, statusCode) {
		const coreMessageRegex = /^SystemNotify\/UserNotification\/OrganizationID:\S+/;

		const playlistAddRegex = /^(DbNotify\/Playlist\/OrganizationID:)\S+(\/StationID:)\S+/;
		const playlistNonAddRegex = /^(DbNotify\/Playlist\/OrganizationID:)\S+(\/PlaylistID:)\S+/;

		const updateEventRegex = /^(DbNotify\/Event\/OrganizationID:)\S+(\/PlaylistID:)\S+/;

		const updateAssetRegex = /^(DbNotify\/Asset\/OrganizationID:)\S+(\/AssetID:)\S+/;
		const stationAssetByAssetAndStationRegex = /^DbNotify\/StationAsset\/OrganizationID:.*\/StationID:.*\/AssetID:/;

		const livePlayerHeartbeat = /(Player\/Notify\/)\S+(\/Heartbeat)/; //Only notifies header / root properties.

		const sequencerNotifySnapshotRegex = /(Sequencer\/Notify\/)\S+(\/SequencerSnapshot)/; //returns a full snapshot of the sequencer, GPIO Device, Sequencer Queue, Stream assignments ...
		const sequencerRequestCurrentQueueRegex = /(Sequencer\/Request\/)\S+(\/CurrentQueue)/; //returns a full snapshot of the sequencer, GPIO Device, Sequencer Queue,. Stream assignments ...
		const sequencerExtendCurrentQueueBroadcastRegex = /(Sequencer\/Request\/)\S+(\/ExtendCurrentQueueBroadcast)/; //returns a full snapshot of the sequencer, GPIO Device, Sequencer Queue,. Stream assignments ...
		const sequencerModeRequestRegex = /Sequencer\/Request\/([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}\/){3}Mode\/[1-4]/; // Change sequencer mode response
		const sequencerActionRequestRegex = /Sequencer\/Request\/([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}\/){3}(PlayNext|Stop|Pause|Play)$/;
		const sequencerEndActionRequestRegex = /(Sequencer\/Request\/)\S+(\/Chain\/)\S+(\/StopChain|SegueChain)/;
		const sequencerSyncToEventRegex = /Sequencer\/Request\/([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}\/){3}SyncToEvent\/([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12})/;
		const sequencerStartStopPlaylistRequestRegex = /Sequencer\/Request\/([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}\/){3}(StartCustomPlaylist|StopCustomPlaylist)$/;

		const livePlayerSnapshot = /(LivePlayer\/(Notify|Request)\/)\S+(\/LiveSnapshot)/;
		const livePlayerConferenceSnapshot = /(LivePlayer\/(Notify|Request)\/)\S+(\/ConferenceSnapshot)/;
		const livePlayerLiveMetadata = /(Player\/Notify\/LiveMetadata\/)\S+/;
		const transferHost = /LivePlayer\/StudioUpdateRole/;
		const studioKickMessageRegex = /LivePlayer\/StudioKick/;
		const playerOnline = /Player\/Notify\/\S+\/Online/;

		try {
			if (!livePlayerHeartbeat.test(topic)) {
				console.log(`Received message from the topic ${topic}`, message);
			}

			//First see if this is a personal direct message response, an InvoiceReceipt?
			if (topic.startsWith(`UI/InvoiceReceipt/${this.uniqueID}`)) {
				console.log(`Invoice Receipt: ${topic}, Topic: ${message.InvoiceTopic}`);

				message.InvoiceTopic = message.InvoiceTopic.replaceAll(".", "/");

				const resultData = JSON.parse(message.InvoiceResultData);
				this.onMessageArrived(message.InvoiceTopic, resultData.Value, resultData.StatusCode);
			}
			else if (sequencerNotifySnapshotRegex.test(topic) || sequencerRequestCurrentQueueRegex.test(topic)) {
				// sequencerSnapshot message
				store.dispatch("sequencerSnapshotResponse", message);
			}
			else if (sequencerExtendCurrentQueueBroadcastRegex.test(topic)) {
				// sequencerExtendCurrentQueueBroadcast message
			}
			else if (playlistNonAddRegex.test(topic)) { // Modify/Delete playlist
				store.dispatch("updateSubscribedPlaylist", message);
			}
			else if (playlistAddRegex.test(topic)) {
				// playlist message
				store.commit("addPlaylistEvent", message);
			}
			else if (updateEventRegex.test(topic)) {
				store.dispatch("playlistEventMessage", message);
			}
			else if (sequencerModeRequestRegex.test(topic)) {
				store.dispatch("sequencerModeResponse", {topic, message, statusCode});
			}
			else if (sequencerActionRequestRegex.test(topic) || sequencerEndActionRequestRegex.test(topic)) {
				store.dispatch("sequencerActionResponse", {topic, message, statusCode});
			}
			else if (livePlayerHeartbeat.test(topic)) {
				store.dispatch("playerHeartBeat", message);
			}
			else if (updateAssetRegex.test(topic)) {
				store.dispatch("assetMessage", message);
			}
			else if (stationAssetByAssetAndStationRegex.test(topic)) {
				store.dispatch("stationAssetMessage", message);
			}
			else if (coreMessageRegex.test(topic)) {
				store.dispatch("notificationMessageReceived", message);
			}
			else if (studioKickMessageRegex.test(topic)) {
				store.dispatch("studioKickMessageReceived", message);
			}
			else if (livePlayerSnapshot.test(topic)) {
				store.dispatch("livePlayerSnapshotResponse", message);
			}
			else if (livePlayerConferenceSnapshot.test(topic)) {
				store.dispatch("livePlayerConferenceSnapshotResponse", {topic, message});
			}
			else if (livePlayerLiveMetadata.test(topic)) {
				store.dispatch("livePlayerLiveMetadataResponse", message);
			}
			else if (transferHost.test(topic)) {
				if (store.getters.getStudioSettings()?.reference === message.studio) {
					store.commit("setAcceptTransferHostOverlay", true);
				}
			}
			else if (playerOnline.test(topic)) {
				store.dispatch("playerOnline", {message});
			}
			else if (sequencerSyncToEventRegex.test(topic)) {
				const stationID = topic.split("/")[4];
				store.dispatch("sequencerSyncActionResponse", {stationID, message, statusCode});
			}
			else if (sequencerStartStopPlaylistRequestRegex.test(topic)) {
				const stationID = topic.split("/")[2];
				store.dispatch("sequencerStartStopPlaylistResponse", {stationID, statusCode, message});
			}
			else {
				//unsupported messages
				console.log(`unsupported WS messages - ${topic}: ${message}`);
			}
		} catch (e) {
			console.log(`Error in convertToWSForIoTCore:  ${e}`);
		}
	},

	invoiceSubscription() {
		this.addSubscription(`UI/InvoiceReceipt/${this.uniqueID}/`);
	},

	coreMessageSubscription(orgID) {
		this.addSubscription(`SystemNotify/UserNotification/OrganizationID:${orgID}/#`)
	},

	sequencerSnapshotSubscription(stationID, orgID, subscribe) {
		if (subscribe) {
			this.addSubscription(
				`Sequencer/Notify/${orgID}/${stationID}/+/SequencerSnapshot/#`
			);
		}
		else {
			this.removeSubscription(
				`Sequencer/Notify/${orgID}/${stationID}/+/SequencerSnapshot/#`
			);
		}
	},

	sequencerSnapshotRequest(orgID, stationID, payload) {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/CurrentQueue`,
			JSON.stringify(payload),
			true
		);

		const MAX_RETRIES = 3;
		let retryCount = 0;
		let delay = 500; // initial delay in ms

		const checkSequencer = () => {
			const sequencer = store.getters.getSequencer(stationID);
			if (sequencer) {
				return;
			}

			retryCount++;

			if (retryCount <= MAX_RETRIES) {
				console.warn(
					`Sequencer not found for station ${stationID}. Retry ${retryCount}/${MAX_RETRIES} in ${delay}ms.`
				);
				WorkerTimer.setTimeout(() => {
					delay *= 2; // exponential backoff (500ms, 1s, 2s)
					checkSequencer();
				}, delay);
			}
			else {
				// Max retries reached, notify user
				store.commit("SHOW_NOTIFICATION_WITH_TYPE", {
					message: "It wasn't possible to get the current playing playlist."
				});
			}
		};

		// Start checking
		checkSequencer();
	},

	sequencerSnapshotExtendRequest(stationID, orgID, payload) {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/ExtendCurrentQueueBroadcast`,
			JSON.stringify(payload),
			true
		);
	},

	SequencerStartCustomPlaylist(orgID, stationID, payload) {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/StartCustomPlaylist`,
			payload,
			true
		);
	},

	SequencerStopCustomPlaylist(orgID, stationID, payload) {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/StopCustomPlaylist`,
			payload,
			true
		);
	},

	stationSubscription(stationID, subscribe) {
		if (subscribe) {
			this.addSubscription(`DbNotify/Station/OrganizationID:${stationID}/#`);
		}
		else {
			this.removeSubscription(`DbNotify/Station/OrganizationID:${stationID}/#`);
		}
	},

	playlistSubscription(playlistID, orgID, subscribe) {
		if (subscribe) {
			this.addSubscription(`DbNotify/Playlist/OrganizationID:${orgID}/PlaylistID:${playlistID}/#`);
		}
		else {
			this.removeSubscription(`DbNotify/Playlist/OrganizationID:${orgID}/PlaylistID:${playlistID}/#`);
		}
	},

	playlistEventSubscription(playlistID, orgID, subscribe) {
		if (subscribe) {
			this.addSubscription(`DbNotify/Event/OrganizationID:${orgID}/PlaylistID:${playlistID}/#`);
		}
		else {
			this.removeSubscription(`DbNotify/Event/OrganizationID:${orgID}/PlaylistID:${playlistID}/#`);
		}
	},

	assetSubscription(assetID, orgID, subscribe) {
		if (subscribe) {
			this.addSubscription(`DbNotify/Asset/OrganizationID:${orgID}/AssetID:${assetID}/#`);
		}
		else {
			this.removeSubscription(`DbNotify/Asset/OrganizationID:${orgID}/AssetID:${assetID}/#`);
		}
	},

	stationAssetSubscription(stationID, assetID, orgID, subscribe) {
		if (subscribe) {
			this.addSubscription(`DbNotify/StationAsset/OrganizationID:${orgID}/StationID:${stationID}/AssetID:${assetID}/#`);
		}
		else {
			this.removeSubscription(`DbNotify/StationAsset/OrganizationID:${orgID}/StationID:${stationID}/AssetID:${assetID}/#`);
		}
	},

	SequencerModeRequest(orgID, stationID, mode, payload) {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/Mode.${mode}`,
			JSON.stringify(payload),
			true
		);
	},

	SequencerActionRequest(orgID, stationID, action, msg = "") {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/${action}`,
			JSON.stringify(msg),
			true
		);
	},

	SequencerToggleEndActionRequest(orgID, stationID, eventID, chain, msg) {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/Chain/${eventID}/${chain}`,
			JSON.stringify(msg),
			true
		);
	},

	// Studio related subscriptions
	SequencerStartLiveRequest(orgID, stationID, payload) {
		console.groupCollapsed(
			`StartLive [${new Date().toISOString()}]`
		);
		console.log(`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/StartLive/`);
		console.log("Payload: ", payload);
		console.groupEnd();

		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/StartLive/`,
			JSON.stringify(payload)
		);
	},

	SequencerEndLiveRequest(orgID, stationID, payload) {
		this.publish(
			`Sequencer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/EndLive/`,
			JSON.stringify(payload)
		);
	},

	PlayerSIPConnectRequest(orgID, stationID, payload) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/ConnectStudio/`,
			JSON.stringify(payload)
		);
	},

	PlayerSIPDisconnectRequest(orgID, stationID, payload) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/DisconnectStudio/`,
			JSON.stringify(payload)
		);
	},

	PlayerOnlineSubscription(orgID, stationID, playerKey, subscribe) {
		const topic = `Player/Notify/${orgID}/${stationID}/+/Online/`;
		if (subscribe) {
			this.addSubscription(topic);
		}
		else {
			this.removeSubscription(topic);
		}
	},

	PlayerHeartbeatSubscription(orgID, stationID, subscribe) {
		const topic = `Player/Notify/${orgID}/${stationID}/+/Heartbeat/`;
		if (subscribe) {
			this.addSubscription(topic);
		}
		else {
			this.removeSubscription(topic);
		}
	},

	LivePlayerSnapshotSubscription(orgID, stationID, subscribe) {
		const topic = `LivePlayer/Notify/${orgID}/${stationID}/+/LiveSnapshot/`;
		if (subscribe) {
			this.addSubscription(topic);
		}
		else {
			this.removeSubscription(topic);
		}
	},

	LivePlayerConferenceSubscription(orgID, stationID, subscribe) {
		const topic = `LivePlayer/Notify/${orgID}/${stationID}/+/ConferenceSnapshot/`;
		if (subscribe) {
			this.addSubscription(topic);
		}
		else {
			this.removeSubscription(topic);
		}
	},

	LivePlayerLiveMetadataSubscription(stationID, subscribe) {
		const topic = `Player/Notify/LiveMetadata/${stationID}/+/`;
		if (subscribe) {
			this.addSubscription(topic);
		}
		else {
			this.removeSubscription(topic);
		}
	},

	LivePlayerTransferHostSubscription(stationID, subscribe) {
		const topic = `LivePlayer/StudioUpdateRole`;
		if (subscribe) {
			this.addSubscription(topic);
		}
		else {
			this.removeSubscription(topic);
		}
	},

	LivePlayerKickHostStudioSubscription(subscribe) {
		const topic = `LivePlayer/StudioKick`;
		if (subscribe) {
			this.addSubscription(topic);
		}
		else {
			this.removeSubscription(topic);
		}
	},

	LivePlayerActionRequest(organizationID, stationID, action, payload) {
		this.publish(
			`LivePlayer/Request/${organizationID}/${stationID}/00000000-0000-0000-0000-000000000000/${action}`,
			JSON.stringify(payload)
		);
	},

	LivePlayerSnapshotRequest(stationID, orgID) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/00000000-0000-0000-0000-000000000000/LiveSnapshot/`,
			"",
			true,
			true
		);
	},

	LivePlayerConferenceRequest(orgID, stationID, playerKey) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/${playerKey}/ConferenceSnapshot/`,
			"",
			true,
			true
		);
	},

	LivePlayerMuteStudioMicRequest(orgID, stationID, playerKey, studio) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/${playerKey}/MuteStudio/`,
			JSON.stringify({"studio": studio})
		);
	},

	LivePlayerUnmuteStudioMicRequest(orgID, stationID, playerKey, studio) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/${playerKey}/UnmuteStudio/`,
			JSON.stringify({"studio": studio})
		);
	},

	LivePlayerSetMixingBufferConfiguration(orgID, stationID, playerKey, automatic, adjustment) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/${playerKey}/ConfigureMixingBuffer/`,
			JSON.stringify({
				automatic,
				adjustment
			})
		);
	},

	// todo: backward compatibility function. Remove on next astrum release
	LivePlayerSetMixingBufferDepth(orgID, stationID, playerKey, depth) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/${playerKey}/SetMixingBufferDepth/`,
			JSON.stringify({depth})
		);
	},

	LivePlayerTransferHost(orgID, stationID, playerKey, studio, role) {
		this.publish(
			`LivePlayer/Request/${orgID}/${stationID}/${playerKey}/StudioUpdateRole/`,
			JSON.stringify({studio, role})
		);
	},

	LivePlayerTransferHostWebRTC(stationID, playerKey, studio, role) {
		this.publish(
			`LivePlayer/StudioUpdateRole`,
			JSON.stringify(({studio, role}))
		);
	},

	LivePlayerKickHostStudioWebRTC(orgID, stationID, peer) {
		this.publish(
			`LivePlayer/StudioKick`,
			JSON.stringify({orgID: orgID, stationID: stationID, peer: peer})
		);
	}
}
